// Calcula o encargo (taxa) de uma parcela conforme a forma de pagamento.
// Identifica a forma pelo NOME (as formas no banco têm apenas _id/nome/ativo,
// sem o campo `tipo`), evitando depender de ids fixos de outro ambiente.
export default function calculaEncargos(valor, formData, item) {
  const forma = (item && item.formaPagamento) || formData.formaPagamento;
  if (!forma) return 0;

  const nome = (forma.nome || '').toLowerCase();
  const ehCredito = nome.includes('crédito') || nome.includes('credito');
  const ehBoleto = nome.includes('boleto');

  // ── Cartão de crédito ────────────────────────────────────────────────
  if (ehCredito) {
    if (!formData.operadora) return 0;

    // Crédito à vista — taxa à vista (já considera recebimento em D+1)
    if (nome.includes('vista')) {
      const taxa = (Number(formData.operadora.txCreditoAVista) || 0) / 100;
      return valor * taxa;
    }

    // Crédito parcelado
    if (nome.includes('parcelado')) {
      // Sem definição de antecipação (campo vazio) → não calcula taxa
      if (!formData.antecipacaoAutomatica) return 0;

      let taxa;
      if (formData.antecipacaoAutomatica === 'sim') {
        // Antecipado: taxa do nº de parcelas escolhido (índice parcelas-1)
        const idx = (formData.quantidadeParcelas || formData.parcelas || 1) - 1;
        const arr = formData.operadora.taxasAntecipacao || [];
        taxa = (Number(arr[idx]) || 0) / 100;
      } else {
        // Sem antecipação ('nao'): taxa de crédito parcelado por parcela
        taxa = (Number(formData.operadora.txCreditoParcelado) || 0) / 100;
      }
      return valor * taxa;
    }

    return 0;
  }

  // ── Boleto ───────────────────────────────────────────────────────────
  if (ehBoleto) {
    if (!formData.bancoEmissor) return 0;
    const taxaEmissao = Number(formData.bancoEmissor.taxaEmissao) || 0;
    const taxaAntecipacao =
      formData.antecipacaoAutomatica === 'sim'
        ? (Number(formData.bancoEmissor.taxaAntecipacao) || 0) / 100
        : 0;
    return taxaEmissao + valor * taxaAntecipacao;
  }

  return 0;
}